import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";
import { useData } from "../../config/DataContext";

const Experience = () => {
  const { experience } = useData();

  return (
    <div className="w-full font-bodyFont flex flex-col gap-16">
      <div>
        <div className="flex flex-col gap-4 mb-10">
          <p className="text-sm text-cyan-400 tracking-[4px] uppercase">Work History</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white font-titleFont">Job Experience</h2>
        </div>
        <div className="w-full border-l-2 border-cyan-500/30 flex flex-col gap-8 pl-8">
          {experience.map((items, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <ResumeCard
                title={items.title}
                subTitle={items.subTitle}
                result={items.result}
                company_link={items.company_link}
                des={items.des}
                Backend={items.Backend}
              />
            </motion.div>
          ))}
        </div>
      </div>

      {/* <div>
        <div className="flex flex-col gap-4 mb-10">
          <p className="text-sm text-cyan-400 tracking-[4px] uppercase">Additional</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white font-titleFont">Trainer Experience</h2>
        </div>
        <div className="w-full border-l-2 border-cyan-500/30 flex flex-col gap-8 pl-8">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <ResumeCard
              title="Flutter Developer"
              subTitle="Keron Infotech Company - (Jun,2020 - Oct,2021)"
              result="India"
              company_link="https://karoninfotech.com/"
              des=""
              Backend=""
            />
          </motion.div>
        </div>
      </div> */}
    </div>
  );
};

export default Experience;
